<mat-table
  [dataSource]="items"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="masterToggle()"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
      >
      </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-avatar size="32" [name]="item.fullName"></sn-avatar>
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (dblclick)="$event.stopPropagation()"
        (change)="selection.toggle(item)"
        [checked]="selection.isSelected(item)"
      >
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="owner">
    <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span *ngIf="item.isIn">{{ item.ownerOrganization.name }}</span>
      <span *ngIf="item.isOut">{{ 'common.me' | t }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="sharer">
    <mat-header-cell *matHeaderCellDef>{{ 'shares.sharedWith' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span *ngIf="item.isOut">{{ item.sharerOrganization.name }}</span>
      <span *ngIf="item.isIn">{{ 'common.me' | t }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="object">
    <mat-header-cell *matHeaderCellDef>{{ 'common.object' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-icon>{{ item.object?.icon }}</sn-icon>
      <span>{{ item.object?.name }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="objectType">
    <mat-header-cell *matHeaderCellDef mat-sort-header="objectContentType">{{ 'common.type' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.object?.contentType }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="direction">
    <mat-header-cell *matHeaderCellDef>{{ 'shares.direction' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.direction }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <mat-header-cell *matHeaderCellDef>{{ 'common.start' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.startDate | fsFormatDate : 'mediumDate' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="endDate">
    <mat-header-cell *matHeaderCellDef>{{ 'common.end' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.endDate | fsFormatDate : 'mediumDate' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef>{{ 'common.status' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-share-status [status]="item.status"></sn-share-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    [class.mat-row--selected]="selection?.isSelected(item)"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
